module.exports = __webpack_public_path__ + "static/media/jackpots-lvl2.64571e29.png";